import { lazy } from 'react';

export default {
  exact: false,
  name: 'cashout-to-some-else',
  protected: true,
  path: '/cashout-to-some-else',
  component: lazy(() =>
    import('containers/GatewayCashout/toSomeOneElse'),
  ),
};
